import { lazy } from "react"
import NewNoteView from "../views/new-note-view/new-note-view"
import {
  NEW_NOTE_VIEW,
  NOTE_VIEW,
  NOTES_LIST_VIEW,
} from "@/features/notes/routes/route-list.ts"
import NotesPage from "@/features/notes/views/notes-page/notes-page.tsx"
import DesktopSidebarLayout from "@/layouts/desktop-sidebar-layout/desktop-sidebar-layout.tsx"
import NoMenuLayout from "@/layouts/no-menu-layout/no-menu-layout.tsx"

const NoteEditorView = lazy(
  () => import("@/features/notes/views/note-editor-view/note-editor-view"),
)

export const noteRoutes = [
  {
    path: `${NEW_NOTE_VIEW}/:animalId`,
    element: <NewNoteView />,
  },
  {
    path: NEW_NOTE_VIEW,
    element: <NewNoteView />,
  },
  {
    path: `${NOTE_VIEW}/:noteId`,
    element: <NoteEditorView />,
  },
  {
    path: NOTES_LIST_VIEW,
    element: <NotesPage />,
  },
]

const MOBILE_NOTES_ROUTES = [
  {
    element: <NoMenuLayout />,
    children: noteRoutes,
  },
]

const DESKTOP_NOTES_ROUTES = [
  {
    element: <DesktopSidebarLayout />,
    children: noteRoutes,
  },
]

export const getNoteRoutes = (isDesktop: boolean) => {
  return isDesktop ? DESKTOP_NOTES_ROUTES : MOBILE_NOTES_ROUTES
}
